import { useState, useRef, useEffect, useMemo } from "react";
import { buildTreeController } from "./buildTreeController.js";
import { ROOT_NODE_ID } from "./constants.js";
const useCheckboxTreeController = ({
  tree,
  compactMode,
  onEmitSelected,
  onInitialized
}) => {
  const [expandedNodeId, setExpandedNodeId] = useState(
    ROOT_NODE_ID
  ), [preSelected, setPreselected] = useState(void 0), treeController = useRef(null), [treeState, setTreeState] = useState([]), hookRef = useRef({ onEmitSelected, onInitialized, compactMode });
  hookRef.current.onEmitSelected = onEmitSelected, hookRef.current.onInitialized = onInitialized, hookRef.current.compactMode = compactMode, useEffect(() => {
    var _a, _b;
    if (!(tree != null && tree.length))
      return;
    hookRef.current.onEmitSelected([]), setTreeState([]), treeController.current = buildTreeController(tree);
    const rootNode = treeController.current[ROOT_NODE_ID];
    return rootNode.subscribe((state, selected, expandedNode) => {
      selected && hookRef.current.onEmitSelected(selected), setTreeState(state), setExpandedNodeId(expandedNode);
    }), hookRef.current.compactMode ? (_a = treeController.current[ROOT_NODE_ID]) == null || _a.setGlobalTreeMode(
      "ONLY_NODE_AND_1_LEVEL_CHILDREN"
    ) : (_b = treeController.current[ROOT_NODE_ID]) == null || _b.setGlobalTreeMode("DEFAULT"), rootNode.emit(!1), hookRef.current.onInitialized(), () => rootNode.unsubscribe();
  }, [tree]), useEffect(() => {
    var _a, _b;
    preSelected && ((_b = (_a = treeController.current) == null ? void 0 : _a[ROOT_NODE_ID]) == null || _b.setSelection(preSelected));
  }, [preSelected]), useEffect(() => {
    var _a, _b, _c, _d;
    compactMode ? (_b = (_a = treeController.current) == null ? void 0 : _a[ROOT_NODE_ID]) == null || _b.setGlobalTreeMode(
      "ONLY_NODE_AND_1_LEVEL_CHILDREN"
    ) : (_d = (_c = treeController.current) == null ? void 0 : _c[ROOT_NODE_ID]) == null || _d.setGlobalTreeMode("DEFAULT");
  }, [compactMode]);
  const callbacks = useMemo(() => ({
    expand: (uuid) => {
      var _a;
      (_a = treeController.current) == null || _a[uuid].expand(!0);
    },
    collapse: (uuid) => {
      var _a;
      (_a = treeController.current) == null || _a[uuid].collapse();
    },
    select: (uuid) => {
      var _a;
      (_a = treeController.current) == null || _a[uuid ?? ROOT_NODE_ID].select();
    },
    deselect: (uuid) => {
      var _a;
      (_a = treeController.current) == null || _a[uuid ?? ROOT_NODE_ID].deselect();
    },
    search: (str) => {
      var _a;
      (_a = treeController.current) == null || _a[ROOT_NODE_ID].find(str);
    },
    showNode: (uuid) => {
      var _a, _b, _c, _d;
      (_a = treeController.current) == null || _a[ROOT_NODE_ID].collapse(), (_b = treeController.current) == null || _b[ROOT_NODE_ID].resetSearch();
      const label = ((_c = treeController == null ? void 0 : treeController.current) == null ? void 0 : _c[uuid].reg.label) ?? "";
      (_d = treeController.current) == null || _d[uuid].expand(!1);
      const intId = window.setInterval(() => {
        const el = document.getElementById(uuid);
        el && (el.scrollIntoView(), clearInterval(intId));
      }, 100);
      return label;
    }
  }), []);
  return {
    expandedNode: expandedNodeId,
    setPreselected,
    treeState,
    ...callbacks
  };
};
export {
  useCheckboxTreeController
};
//# sourceMappingURL=useCheckboxTreeController.js.map
